import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyStreetAddress1 = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_company_compliance_details.modal.form.field.address.street_address_1.label')}
      name="companyAddress"
      render={({ field }) => {
        return <Input {...field} size="sm" />
      }}
    />
  )
}
